function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card } from "../../components/analytics-kit";
import { Loader, ChartLoader } from "../../components/loaders";
import Error from "../../components/error";
import Chart from "../../components/chart";
import { hasTenantFeature } from "../../functions/tenant-features";
import { trendLabel, cleanTitle, titleCase } from "../sales/territory-common";
import { Link } from "react-router-dom";
import { Menu } from "../products/px-common";
import { dateShort } from "../sales/rep-common";
import { fetchStore, fetchStoreProducts, fetchStoreCustomers, isInProgressRange, isAdminUser, stMoney, stDollars, stCount, stPct, stChange, storeName, typeLabel, categoryKey, categoryName, categoryLeaf, stRangeLabel, goalPhrase, periodWord, compareLabel, GoalBar, Change } from "./common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * Store page (Stores redesign 2026-10-09, PlunkDocs mockups/stores-redesign-2026-10-09.html, board "2 · A store").
 *
 *   GET /v1/store/performance/{range}/{storeId}             KPIs + daily trend + categories (merged) + customer counts
 *   GET /v1/store/performance/{range}                       the roster row: goal, pacing, paced change, chain average
 *   GET /v1/store/performance/{range}/{storeId}/products    top products here + rank across all stores (1.0.174)
 *   GET /v1/store/performance/{range}/{storeId}/customers   top buyers + new buyers here, linked to People (1.0.174)
 *
 * The sales chart is unchanged. Styles: st-* in sass/v2/_stores.scss.
 */
class StoreDetailView extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "openProduct", p => {
      if (p.matched && p.productId) this.props.history.push({
        pathname: `/Products/${this.range()}/product/${encodeURIComponent(p.productId)}`,
        state: {
          title: p.title
        }
      });
    });
    _defineProperty(this, "openCustomer", c => {
      if (c.peopleId) this.props.history.push(`/Customers/account/${encodeURIComponent(c.peopleId)}`);
    });
    this.state = {
      data: null,
      roster: null,
      products: undefined,
      customers: undefined,
      custTab: "top",
      error: false
    };
    this._alive = true;
  }
  range() {
    return this.props.params && this.props.params.range || getGlobalRange();
  }
  storeId() {
    return decodeURIComponent(this.props.params && this.props.params.storeId || "");
  }
  componentDidMount() {
    this.load();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range) return;
      const target = `/Stores/${range}/store/${encodeURIComponent(this.storeId())}`;
      if (window.location.pathname === target) {
        this.reset(() => this.load());
      } else {
        this.props.history.push(target);
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    const p = prev.params || {};
    const c = this.props.params || {};
    if (p.range !== c.range || p.storeId !== c.storeId) this.reset(() => this.load());
  }
  reset(cb) {
    this.setState({
      data: null,
      roster: null,
      products: undefined,
      customers: undefined,
      error: false
    }, cb);
  }
  load() {
    const range = this.range();
    const id = this.storeId();
    fetchStore(`/store/performance/${range}/${encodeURIComponent(id)}`).then(d => this._alive && this.setState({
      data: d || {}
    })).catch(() => this._alive && this.setState({
      error: true
    }));
    fetchStore(`/store/performance/${range}`).then(r => this._alive && this.setState({
      roster: r || {}
    })).catch(() => this._alive && this.setState({
      roster: {}
    }));
    fetchStoreProducts(range, id, 8).then(r => this._alive && this.setState({
      products: r && r.items || []
    })).catch(() => this._alive && this.setState({
      products: null
    }));
    fetchStoreCustomers(range, id, 8).then(r => this._alive && this.setState({
      customers: r || null
    })).catch(() => this._alive && this.setState({
      customers: null
    }));
  }
  // Daily rows are noisy over long windows — bucket to weeks past ~70 points.
  chartData(trend) {
    if (!trend || trend.length < 2) return null;
    let rows = trend.map(t => ({
      date: String(t.date).slice(0, 10),
      revenue: Number(t.revenue) || 0,
      orders: Number(t.orders) || 0
    }));
    let bucket = "day";
    if (rows.length > 70) {
      bucket = "week";
      const byWeek = new Map();
      rows.forEach(r => {
        const d = new Date(r.date + "T00:00:00");
        const monday = new Date(d);
        monday.setDate(d.getDate() - (d.getDay() + 6) % 7);
        const key = monday.toISOString().slice(0, 10);
        const cur = byWeek.get(key) || {
          date: key,
          revenue: 0,
          orders: 0
        };
        cur.revenue += r.revenue;
        cur.orders += r.orders;
        byWeek.set(key, cur);
      });
      rows = [...byWeek.values()].sort((a, b) => a.date < b.date ? -1 : 1);
    }
    const data = [["Period", "Revenue", "Orders"]];
    rows.forEach(r => data.push([trendLabel(r.date, bucket === "day" ? "day" : "day"), Math.round(r.revenue * 100) / 100, r.orders]));
    this._bucket = bucket;
    return data;
  }

  // ---- goal section ----
  renderGoal(row, roster, range) {
    const goal = Number(row && row.targetRevenue) || 0;
    const phrase = goalPhrase(range);
    const title = phrase.charAt(0).toUpperCase() + phrase.slice(1);
    if (!goal) {
      return /*#__PURE__*/React.createElement("section", {
        className: "st-goal"
      }, /*#__PURE__*/React.createElement("b", {
        className: "st-h"
      }, title), /*#__PURE__*/React.createElement("span", {
        className: "st-muted"
      }, "No goal is set for this store", isAdminUser() ? "." : ". Goals are set by an administrator."), isAdminUser() ? /*#__PURE__*/React.createElement(Link, {
        className: "st-link",
        to: "/Stores/targets"
      }, "Set store goals") : null);
    }
    const inProgress = roster && roster.inProgress != null ? !!roster.inProgress : isInProgressRange(range);
    const rev = Number(row.revenue) || 0;
    const att = row.attainmentPct != null ? row.attainmentPct : rev / goal * 100;
    let line;
    if (inProgress) {
      const proj = row.projectedRevenue != null ? Number(row.projectedRevenue) : null;
      const parts = [];
      if (proj != null && row.paceAttainmentPct != null) parts.push(`On track to finish around ${stMoney(proj)}, ${stPct(row.paceAttainmentPct)} of the goal.`);
      if (rev >= goal) parts.push("The goal is already reached.");else if (Number(row.neededPerDay) > 0) parts.push(`Needs about ${stMoney(row.neededPerDay)} a day for the rest of the ${periodWord(range)} to reach it.`);
      line = parts.join(" ");
    } else {
      line = rev >= goal ? `Finished at ${stPct(att)} of the goal.` : `Finished ${stMoney(goal - rev)} short of the goal.`;
    }
    return /*#__PURE__*/React.createElement("section", {
      className: "st-goal"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, title), /*#__PURE__*/React.createElement(GoalBar, {
      pct: att,
      big: true
    }), /*#__PURE__*/React.createElement("span", {
      className: "st-goal-n"
    }, /*#__PURE__*/React.createElement("b", null, stMoney(rev)), " of ", stMoney(goal), " (", stPct(att), ")"), line ? /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-goal-line"
    }, line) : null);
  }

  // ---- what sells here ----
  renderCategories(data) {
    // Merge "Sofas" / "SOFA" again client-side (older backends send them apart).
    const merged = new Map();
    (data.topCategories || []).forEach(c => {
      const k = categoryKey(c.category);
      const cur = merged.get(k) || {
        revenue: 0,
        units: 0,
        share: 0,
        chain: null,
        names: []
      };
      cur.revenue += Number(c.revenue) || 0;
      cur.units += Number(c.units) || 0;
      cur.share += Number(c.sharePct) || 0;
      if (c.chainSharePct != null) cur.chain = Number(c.chainSharePct);
      cur.names.push([c.category, Number(c.revenue) || 0]);
      merged.set(k, cur);
    });
    const rows = [...merged.entries()].map(([k, r]) => {
      const names = r.names.sort((a, b) => b[1] - a[1]).map(n => n[0]);
      const normal = names.find(n => {
        const leaf = categoryLeaf(n);
        return !(leaf === leaf.toUpperCase() && /[A-Za-z]/.test(leaf));
      });
      return {
        key: k,
        name: categoryName(normal || names[0]),
        ...r
      };
    }).sort((a, b) => b.revenue - a.revenue).slice(0, 8);
    if (!rows.length) return null;
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "What sells here"), /*#__PURE__*/React.createElement("span", {
      className: "st-fill"
    }), /*#__PURE__*/React.createElement("span", {
      className: "st-muted st-small"
    }, "share of this store's sales, all stores in grey")), /*#__PURE__*/React.createElement("table", {
      className: "st-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Category"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Share"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.key
    }, /*#__PURE__*/React.createElement("td", null, r.name), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, stCount(r.units)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, /*#__PURE__*/React.createElement("b", null, stMoney(r.revenue))), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, stPct(r.share), r.chain != null ? /*#__PURE__*/React.createElement("span", {
      className: "st-sub"
    }, " ", stPct(r.chain)) : null))))));
  }

  // ---- top products here ----
  renderProducts() {
    const {
      products
    } = this.state;
    if (products === null) return null;
    const range = this.range();
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Top products here"), /*#__PURE__*/React.createElement("span", {
      className: "st-fill"
    }), /*#__PURE__*/React.createElement(Link, {
      className: "st-link",
      to: `/Products/${range}`
    }, "All products")), products === undefined ? /*#__PURE__*/React.createElement(ChartLoader, null) : products.length ? /*#__PURE__*/React.createElement("table", {
      className: "st-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Product"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Units"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Revenue"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Rank in all stores"))), /*#__PURE__*/React.createElement("tbody", null, products.map(p => /*#__PURE__*/React.createElement("tr", {
      key: p.productId,
      className: p.matched ? "st-click" : "",
      tabIndex: p.matched ? 0 : undefined,
      onClick: () => this.openProduct(p),
      onKeyDown: e => {
        if (e.key === "Enter") this.openProduct(p);
      },
      title: p.matched ? undefined : "Not in your product catalog, so it has no product page"
    }, /*#__PURE__*/React.createElement("td", {
      className: "st-wrap"
    }, titleCase(cleanTitle(p.title)) || p.productId), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, stCount(p.units)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, /*#__PURE__*/React.createElement("b", null, stMoney(p.revenue))), /*#__PURE__*/React.createElement("td", {
      className: "n st-muted"
    }, p.chainRank ? `#${stCount(p.chainRank)}` : "-"))))) : /*#__PURE__*/React.createElement("p", {
      className: "st-muted st-pad"
    }, "No products sold here in this date range."), products && products.length ? /*#__PURE__*/React.createElement("div", {
      className: "st-foot"
    }, "Click a product for its page.") : null);
  }

  // ---- customers at this store ----
  renderCustomers(range) {
    const {
      customers,
      custTab
    } = this.state;
    if (customers === null) return null;
    if (customers === undefined) return /*#__PURE__*/React.createElement("section", {
      className: "st-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Customers at this store"), /*#__PURE__*/React.createElement(ChartLoader, null));
    if (!Number(customers.customers)) return null; // no customer ids on this store's sales: nothing to show
    const list = (custTab === "new" ? customers.new : customers.top) || [];
    const linked = list.some(c => c.peopleId);
    const unlinked = list.some(c => !c.peopleId);
    return /*#__PURE__*/React.createElement("section", {
      className: "st-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "st-card-h"
    }, /*#__PURE__*/React.createElement("b", {
      className: "st-h"
    }, "Customers at this store"), /*#__PURE__*/React.createElement("span", {
      className: "st-fill"
    }), /*#__PURE__*/React.createElement("span", {
      className: "st-tabs",
      role: "tablist"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "tab",
      "aria-selected": custTab === "top",
      className: custTab === "top" ? "on" : "",
      onClick: () => this.setState({
        custTab: "top"
      })
    }, "Top buyers"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "tab",
      "aria-selected": custTab === "new",
      className: custTab === "new" ? "on" : "",
      onClick: () => this.setState({
        custTab: "new"
      })
    }, "New this ", periodWord(range), " ", /*#__PURE__*/React.createElement("span", {
      className: "n"
    }, stCount(customers.newCount))))), list.length ? /*#__PURE__*/React.createElement("table", {
      className: "st-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Customer"), /*#__PURE__*/React.createElement("th", null, "Last purchase"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Orders"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Spent"))), /*#__PURE__*/React.createElement("tbody", null, list.map(c => /*#__PURE__*/React.createElement("tr", {
      key: c.customerId,
      className: c.peopleId ? "st-click" : "",
      tabIndex: c.peopleId ? 0 : undefined,
      onClick: () => this.openCustomer(c),
      onKeyDown: e => {
        if (e.key === "Enter") this.openCustomer(c);
      }
    }, /*#__PURE__*/React.createElement("td", {
      className: "st-wrap"
    }, /^Customer \d+$/.test(String(c.name || "")) ? c.name : String(c.name || "").toLowerCase().replace(/(^|[\s\/'-])([a-z])/g, (m, x, y) => x + y.toUpperCase())), /*#__PURE__*/React.createElement("td", null, dateShort(c.lastPurchase)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, stCount(c.orders)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, /*#__PURE__*/React.createElement("b", null, stMoney(c.spent))))))) : /*#__PURE__*/React.createElement("p", {
      className: "st-muted st-pad"
    }, custTab === "new" ? `Nobody bought from you for the first time here this ${periodWord(range)}.` : "No customers in this date range."), list.length ? /*#__PURE__*/React.createElement("div", {
      className: "st-foot"
    }, linked ? "Click a customer to open them in People." : "", unlinked ? `${linked ? " " : ""}Customers not in People yet show their customer number.` : "") : null);
  }
  render() {
    if (!hasTenantFeature("storePerformance")) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "Store Performance is not configured for this workspace."));
    }
    const {
      data,
      roster,
      error
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const range = this.range();
    const id = this.storeId();
    const row = roster ? (roster.stores || []).find(s => String(s.storeId) === String(id)) || null : null;
    const name = storeName({
      storeId: id,
      name: data.name,
      type: data.type
    });
    const chart = this.chartData(data.trend);
    const label = compareLabel(roster, range);
    const chg = row ? stChange(row.revenue, row.revenuePrev) : null;
    const asOfEnd = roster && roster.inProgress && roster.asOf ? roster.asOf : roster && roster.end;
    const menu = [isAdminUser() ? {
      key: "goals",
      label: "Store goals",
      onClick: () => this.props.history.push("/Stores/targets")
    } : null, {
      key: "all",
      label: "All stores",
      onClick: () => this.props.history.push(`/Stores/${range}`)
    }];
    const revSub = [];
    if (chg && label) revSub.push(/*#__PURE__*/React.createElement(React.Fragment, {
      key: "c"
    }, /*#__PURE__*/React.createElement(Change, {
      c: chg
    }), " vs ", label));
    if (row && row.sharePct != null) revSub.push(/*#__PURE__*/React.createElement(React.Fragment, {
      key: "s"
    }, revSub.length ? " · " : "", stPct(row.sharePct), " of all store sales"));
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view territory-detail stores-view wa-view st-stores"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: `/Stores/${range}`
      }, "Stores"), " \xB7 Store"),
      title: name,
      subtitle: `${typeLabel(data.type)} · ${stRangeLabel(range, roster && roster.start, asOfEnd)}${label ? ` · changes are against ${label}` : ""}`,
      actions: /*#__PURE__*/React.createElement(Menu, {
        label: "More",
        items: menu,
        triggerCls: "st-more"
      })
    }), roster ? this.renderGoal(row, roster, range) : null, /*#__PURE__*/React.createElement(Ribbon, {
      comparing: null,
      cols: 4,
      tiles: [{
        l: "Revenue",
        v: stMoney(data.revenue),
        s: revSub.length ? /*#__PURE__*/React.createElement(React.Fragment, null, revSub) : ""
      }, {
        l: "Orders",
        v: stCount(data.orders),
        s: `${stCount(data.units)} units`
      }, {
        l: "Average order",
        v: stDollars(data.aov),
        s: roster && Number(roster.chainAov) ? `all stores average ${stDollars(roster.chainAov)}` : ""
      }, {
        l: "Customers",
        v: stCount(data.distinctCustomers),
        s: `${stCount(data.newCustomers)} bought for the first time`
      }]
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, chart && /*#__PURE__*/React.createElement(Card, {
      title: `Sales by ${this._bucket === "week" ? "week" : "day"}`,
      hint: "revenue bars \xB7 orders line"
    }, /*#__PURE__*/React.createElement("div", {
      className: "territory-trend"
    }, /*#__PURE__*/React.createElement(Chart, {
      width: "100%",
      height: "320px",
      chartType: "ComboChart",
      loader: /*#__PURE__*/React.createElement(ChartLoader, null),
      data: chart,
      options: {
        seriesType: "bars",
        series: {
          0: {
            targetAxisIndex: 0,
            color: "#ff6358",
            tooltipFormat: "currency"
          },
          1: {
            type: "line",
            targetAxisIndex: 1,
            color: "#78d237",
            tooltipFormat: "{0:n0}"
          }
        },
        vAxes: {
          0: {
            title: "Revenue",
            format: "short"
          },
          1: {
            title: "Orders",
            format: "0"
          }
        },
        legend: {
          position: "top"
        }
      }
    })))), /*#__PURE__*/React.createElement("div", {
      className: "st-two even"
    }, this.renderCategories(data), this.renderProducts()), this.renderCustomers(range));
  }
}
export default withRouter(StoreDetailView);